import type {
  SellarDistributionAvailabilityDeliveryEstimatesParametersType,
  SellarDistributionAvailabilityDeliveryEstimatesResponseType,
} from "@sellar-io/api-v2/types";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import { useQuery } from "@tanstack/react-query";

export const useSellarDistributionAvailabilityDeliveryEstimates = <
  TData = SellarDistributionAvailabilityDeliveryEstimatesResponseType,
>(
  params: SellarDistributionAvailabilityDeliveryEstimatesParametersType,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.SellarDistributionAvailability,
      params,
    ],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `sellar-distribution-availability/delivery-estimate`,
        params: {
          ...params,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptions(options),
  });
};
